module.exports = __webpack_public_path__ + "img/BAWS_Shield2_1_2.b1c1e35c.png";